import { AxiosHttpGet, AxiosHttpPost } from 'axios-http';
import { REPAIR_CENTER, RMAMANUFATURA } from 'resources/links';
import axios from 'axios';

export function downloadPublicFile(code: string, downloadName: string) {
  return axios({
    url: `${REPAIR_CENTER.downloadPublicFile}?code=${code}`,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const blob = new Blob([response.data], {
      type: 'application/octet-stream',
    });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = downloadName;
    link.click();
  });
}
